import { render, staticRenderFns } from "./FormEditTask.vue?vue&type=template&id=537788a1&"
import script from "./FormEditTask.vue?vue&type=script&lang=js&"
export * from "./FormEditTask.vue?vue&type=script&lang=js&"
import style0 from "./FormEditTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports